import {useCallback, useSyncExternalStore} from 'react'

import {getConnectionTraceIdSnapshot, subscribeToActivationTraceId} from '../ahp/activation-trace'

export function useConnectionTraceId(taskId: string | undefined): string {
  const subscribe = useCallback((listener: () => void) => subscribeToActivationTraceId(taskId, listener), [taskId])
  const getSnapshot = useCallback(() => getConnectionTraceIdSnapshot(taskId), [taskId])

  return useSyncExternalStore(subscribe, getSnapshot, () => '')
}
